import React from 'react';
import { RecordLinking } from 'components';

export const RecordLinkingPage = props => {
    return <RecordLinking {...props} />;
};
